import React from 'react';
import { Table, Button } from 'antd';

const PromoProductsTable = props => {
  const { promo, products, deletePromoduct, fetchPromo } = props;

  const removeProduct = (promo, product) => {
    deletePromoduct(promo.id, product.id).then(
      data => fetchPromo(promo.id),
      err => window.setTimeout(() => fetchPromo(promo.id), 2000),
    );
  };

  const columns = [
    {
      title: 'Product ID',
      dataIndex: 'id',
      key: 'id',
      width: '120px',
    },
    {
      title: 'Product',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Country',
      dataIndex: 'country',
      key: 'country',
    },
    {
      title: 'Image',
      key: 'image_url',
      render: row => <img width="50" height="50" src={row.image_url} alt="" />,
    },

    {
      title: 'Price',
      key: 'price_cents',
      render: row => (
        <span>
          $ {row.price_cents / 100} {row.price_unit}
        </span>
      ),
    },
    {
      title: 'Price Sale',
      key: 'price_sale',
      render: row => <span>{row.price_sale === 0 ? '' : `$ ${row.price_sale / 100} ${row.price_unit}`}</span>,
    },
    {
      title: 'Action',
      key: '',
      align: 'center',
      render: row => <Button onClick={() => removeProduct(promo, row)}>Remove</Button>,
    },
  ];

  if (products.length === 0) {
    return <div>There are no products for this promotion</div>;
  }

  // console.log('products', products);

  return <Table columns={columns} dataSource={products} pagination={false} rowKey={record => record.id} />;
};

export default PromoProductsTable;



// WEBPACK FOOTER //
// ./src/components/Promo/PromoProductsTable.js